<template>
  <v-form
    ref="form"
    v-model="valid"
  > 
  <v-container>
    <v-subheader class="pa-0 ma-0">
      <v-breadcrumbs :items="itemsBreadcrumb">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    </v-subheader>
    <v-container class="ml-4 mt-8 form-container">      
      <v-row>
        <v-col cols="12" align-self="center" class="ml-7 mb-2 label field-resize">
          <p class="ml-4 data-organism">{{$t('dataOrganism')}}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" md="2" lg="2" align-self="center" class="mb-2 label field-resize">
          <p class="ml-4">{{$t('organismName')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
          <v-text-field
            v-model="organism.name"
            :counter="30"
            :label="$t('organismName')+'*'"
            required
            outlined
            dense
            class="input"
            :rules="[
                v => !!v ||  $t('rules.required',{field:$t('name')}),
                v => (v && v.length <= 30) ||  $t('rules.maxLength',{field:$t('name'), number:30}),
                v => (v && v.length >3 ) ||  $t('rules.minLength',{field:$t('name'), number:3})
              ]"
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2" lg="2" align-self="center" class="mb-2 label field-resize">
          <p class="ml-4">{{$t('description')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
         <v-text-field
            v-model="organism.description"
            :label="$t('description')+'*'"
            outlined
            dense
            class="input"
            :rules="[
                v => !!v ||  $t('rules.required',{field:$t('description')}),
                v => (v && v.length <= 30) ||  $t('rules.maxLength',{field:$t('description'), number:30}),
                v => (v && v.length > 4 ) ||  $t('rules.minLength',{field:$t('description'), number:4}),
              ]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" md="2" lg="2" align-self="center" class="mb-2 label field-resize">
          <p class="ml-4">{{$t('phone')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
          <v-text-field
            v-model="organism.telephone"
            :label="$t('phone')+'*'"
            outlined
            dense
            class="input"
            :rules="[
              v => !!v || $t('rules.required',{field:$t('phone')}),
              v => {
                if (!this.validPhone(v)) return $t('rules.telephone');
                if (v.length < 6) return $t('rules.minLength',{field:$t('phone'), number:6});
                return true
              }]"
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2" lg="2" align-self="center" class="mb-2 label field-resize">
          <p class="ml-4">{{$t('email')}}</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
          <v-text-field
            v-model="organism.emailAddress"
            :label="$t('email')"
            
            outlined
            dense
            :rules="[
                v =>  (!v || v.length == 0)? true : /.+@.+\..+/.test(v) || $t('rules.email')
              ]"
            class="input"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <div class="text-right mr-8 buttons">
      <p class="mr-4 required-field">{{$t('requiredFieldsDescription')}}</p>
      <v-btn
        color="#91919c"
        class="mr-3 btn-cancel"
        @click="cancel"
        text
      >
        {{$t('cancelButton')}}
      </v-btn>
      <v-btn
        :disabled="!valid || ( isOrganismEdit && !edited)"
        color="#5f98ed"
        class="mr-3 white--text btn-confirm"
        @click="saveOrganism"
        rounded
      >
        {{$t('acceptButton')}}
      </v-btn>
    </div>
  </v-container>
  </v-form>
</template>

<script>
export default {
  data(){
    return {
      valid: false,
      show: false,
      edited: false,
      loadedOrganism:{},
      organism: {
        name: '',
        description: '',
        telephone: '',
        emailAddress: null,
      },
      selected: '',
      allOrganisms: [],
      itemsBreadcrumb:[
        {
          text: this.$t('organisms'),
          href: '/organism',
        },
        {
          text: this.$t('newOrganism'),
          disabled: true
        }

      ]
    }
  },
  watch:{
    organism:{
      handler:function(newValue){
        let fields = Object.keys(newValue)
        this.edited = false
        var i= 0;
        while(!this.edited && i < fields.length) {
          if(this.loadedOrganism[ fields[i] ] !== newValue[ fields[i] ]){
            this.edited = true  
          } else{
            this.edited = false
            i ++
          }
        }
      },
      deep:true
    }
  },

  mounted(){
    let organismPreloaded= this.$store.getters.getOrganismEdition
    this.loadedOrganism = {...organismPreloaded}
    if(organismPreloaded!== undefined){
      this.organism = organismPreloaded
      this.selected = organismPreloaded.name
    }
    this.itemsBreadcrumb.forEach( (e, index) => {
      if(e.href === '/organism'){
        var el = document.getElementsByClassName("v-breadcrumbs__item")[index];
        el.classList.add("gray");
      } else{
        el = document.getElementsByClassName("v-breadcrumbs__item")[index];
        el.classList.add("blue");
      }
    })

  },
  beforeDestroy(){
    this.$store.commit('setOrganismEdition', undefined)
  },
  computed: {
    organismInfoLoaded: {
      get(){
        return (this.$store.getters.getOrganismEdition !== undefined)
      }
    },
    isOrganismEdit: {
      get(){
        return this.$store.getters.getIsOrganismEditMode
      }
    }
  },
  methods: {
    /*post organismo*/
    saveOrganism() {
      if(this.$refs.form.validate()){     
        if(!this.organismInfoLoaded) {  
          this.$extractions.postOrganism(this.organism).then(()=>{
          this.$store.dispatch('snackAlert', true)
          this.$router.push('/organism')
      }).catch(error=>{
          if(error.toString().includes('409')){
            this.$store.commit('setSnackText', this.$t('rules.organismAlreadyExists'))
            this.$store.commit('setSnackBar', true)
          }
        })
      } else{
          this.$extractions.updateOrganism(this.organism).then(()=>{
            this.$store.dispatch('snackAlert', true)
            this.$router.push('/organism')
          }).catch(error=>{
            if(error.toString().includes('409')){
              this.$store.commit('setSnackText', this.$t('rules.organismAlreadyExists'))
              this.$store.commit('setSnackBar', true)
            }
          })
        }
      }
    },
    cancel() {
      this.$router.push('/organism')
    },
    validPhone(phone){
      const regEx = /[^0-9 ^+ ^-]/g;
      const invalidStrings = phone.match(regEx);
      return !invalidStrings
    }
  },
}

</script>
<style>
  
  .form-container{
    border: 1px solid #eee;
    width: 97%;
    border-radius: 18px;
    font-family: 'Open Sans', 'sans-serif';
  }
  .data-organism{
    color: #91919c;
    font-size: 14px;
    font-weight: 500;
  }
  .input{
    border-radius: 13px!important;
  }
  .v-label{
    font-size: 13px!important;
    font-weight: 500;
    color: #91919c!important;
  }
  .label{
    font-size: 13px!important;
    font-weight: bold;
  }
  .btn-confirm:hover{
    background-color: #5f98ed!important;
  }
  .btn-cancel{
    color: #91919c!important;
  }
  .btn-cancel:hover{
    color: #65656d!important;
  }
  .btn-cancel::before{
    background-color: transparent!important;
  }
  .btn-confirm{
    background-color: #5f98ed!important;
  }
  .required-field{
    font-size: 12px;
  }
  .gray{
    color: #888!important;
  }
  .v-application .blue{
    color: #5f98ed!important;
    background-color: transparent!important;
  }
  @media (max-width: 500px) {
    .input{
      font-size: 13px!important;
    }
  }
  @media (max-width: 397px) {
    .field-resize{
      flex: 0 0 auto!important;
      max-width: 100%!important;
    }
  }
  @media (max-width: 330px) {
    .v-application .text-right{
      margin-right: 0px!important;
    }
  }
</style>